import styled from "styled-components";
import { Button } from "react-bootstrap";

export const AppButton = styled(Button)`
  color: #d12415;
  background-color: transparent;
  font-family: Armata-Regular;
  letter-spacing: 1px;
  font-size: 16px;
  width: 300px;
  padding: 10px 0px;
  border: 1px solid #d12415;
  &:hover {
    outline: none;
    box-shadow: 0 0 3pt 2pt #d12415;
    color: #d12415;
    background-color: transparent;
    border-color: #d12415 !important;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 3pt 2pt #d12415;
    color: #d12415;
    background-color: transparent;
    border-color: #d12415 !important;
  }
`;
